import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Global error listeners for production debugging
if (import.meta.env.PROD) {
  window.addEventListener('error', (e) => {
    console.error('Global error:', e.error || e.message);
  });
  window.addEventListener('unhandledrejection', (e) => {
    console.error('Unhandled promise rejection:', e.reason);
  });
}

createRoot(document.getElementById("root")!).render(<App />);
